import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { useSnackbar } from "notistack";
import { Box, Button, CircularProgress, Stack, TextField, Typography } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";
import { config } from "../App";



const Login = () => {
  const history = useHistory();

  
  const [loading, setLoading] = useState(false);

  const persistLogin = (token, uname, balance) => {
    localStorage.setItem("token", token);
    localStorage.setItem("username", uname);
    localStorage.setItem("balance", balance);
  };


  const { enqueueSnackbar } = useSnackbar();

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  

  const handleChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const validateInput = () => {
    if (!formData.username) {
      enqueueSnackbar("Username is a required field", { variant: "error" });
      return false;
    }
    if (!formData.password) {
      enqueueSnackbar("Password is a required field", { variant: "error" });
      return false;
    }
    return true;
  };



  const login = async () => {
    if (!validateInput()) return;
    setLoading(true);
    try {
      const url = `${config.endpoint}/auth/login`;
      const res = await axios.post(url, {
        username: formData.username,
        password: formData.password,
      });

      persistLogin(res.data.token, res.data.username, res.data.balance);

      enqueueSnackbar("Logged in successfully", { variant: "success" });
      history.push("/");
    } catch (err) {
      const msg =
        err?.response?.data?.message || "Something went wrong. Please try again.";
      enqueueSnackbar(msg, { variant: "error" });
    }finally {
      setLoading(false);
    }
  };

  return (
    <Box className="MuiBox-root">
      <Header>
        <Button
          className="explore-button"
          startIcon={null}
          onClick={() => history.push("/")}
        >
          Back to explore
        </Button>
      </Header>

      <Box className="content">
        <Stack spacing={2} className="form">
        
          <Typography variant="h4">Login</Typography>

          <TextField
            fullWidth
            label="Username"
            name="username"
            value={formData.username}
            onChange={handleChange}
          />

          <TextField
            fullWidth
            label="Password"
            name="password"
            type="password"
            value={formData.password}
            onChange={handleChange}
          />

         
          {/* <Button fullWidth variant="contained" onClick={login}>
            Login to QKart
          </Button> */}
          <Button variant="contained" onClick={login} disabled={loading} fullWidth>
            {loading ? <CircularProgress size={24} /> : "Login to QKart"}
          </Button>

          <Typography align="center">
            Don't have an account? <a href="/register">Register now</a>
          </Typography>
        </Stack>
      </Box>

      <Footer />
    </Box>
  );
};

export default Login;
